/**
 * CRA 只注入 REACT_APP_*；若 .env 仍用 NEXT_PUBLIC_* 则读不到。
 * 同时兼容两种前缀，避免从 Next 文档复制来的配置静默失效。
 */
const PROJECT_ID =
  process.env.REACT_APP_SANITY_PROJECT_ID ||
  process.env.NEXT_PUBLIC_SANITY_PROJECT_ID ||
  ''
const DATASET =
  process.env.REACT_APP_SANITY_DATASET ||
  process.env.NEXT_PUBLIC_SANITY_DATASET ||
  '3chat-blog-data'
const API_VERSION = '2024-01-01'

const BASE_URL = `https://${PROJECT_ID}.apicdn.sanity.io/v${API_VERSION}/data/query/${DATASET}`

export async function sanityFetch<T = unknown>(
  query: string,
  params: Record<string, unknown> = {}
): Promise<T> {
  if (!PROJECT_ID) {
    throw new Error(
      'Missing Sanity project id: set REACT_APP_SANITY_PROJECT_ID in .env.local (Create React App ignores NEXT_PUBLIC_*)'
    )
  }
  const url = new URL(BASE_URL)
  url.searchParams.set('query', query)

  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.set(`$${key}`, JSON.stringify(value))
  })

  const res = await fetch(url.toString())
  if (!res.ok) throw new Error(`Sanity fetch failed: ${res.status}`)

  const data = await res.json()
  return data.result as T
}